import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faTachometer, faTasks, faEye, faPencil, faTrashCan, faVideo, faArrowLeft, faDumbbell, faCheckCircle, faPlus } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import { useRecoilState } from 'recoil';

import { getSessionDetailAPI } from "../../../../../API/Session";
import { putSessionUpdateAPI } from "../../../../../API/Session";
import { getSelectedOptions } from "../../../../../Helpers/selectHelper";
import useLocalStorage from "../../../../../Hooks/useLocalStorage";
import FormErrorBox from "../../../../Reusable/FormErrorBox";
import FormInputField from "../../../../Reusable/FormInputField";
import FormTextareaField from "../../../../Reusable/FormTextareaField";
import FormMultiSelectField from "../../../../Reusable/FormMultiSelectField";
import FormRadioField from "../../../../Reusable/FormRadioField";
import FormListInputField from "../../../../Reusable/FormListInputField";
import { topAlertMessageState, topAlertStatusState, userDetailState } from "../../../../../AppState";
import PickCMSImageModal from "../../../../Reusable/PickCMSImageModal";
import PickCMSVideoModal from "../../../../Reusable/PickCMSVideoModal";
import FormInputFieldWithButton from "../../../../Reusable/FormInputFieldWithButton";
import PageLoadingContent from "../../../../Reusable/PageLoadingContent";


function UserSessionVideoSectionExerciseUpdate() {
    ////
    //// URL parameters.
    ////

    const { uid, sid, vsid, eid } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);
    const [user, setUser] = useRecoilState(userDetailState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [session, setSession] = useLocalStorage(sid, "");
    const [forceURL, setForceURL] = useState("");
    const [isFetching, setFetching] = useState(false);
    const [name, setName] = useState();
    const [type, setType] = useState();
    const [duration, setDuration] = useState();
    const [previewUrl, setPreviewUrl] = useState();
    const [previewDescription, setPreviewDescription] = useState();
    const [restUpcomingName, setRestUpcomingName] = useState();
    const [videoUrl, setVideoUrl] = useState();
    const [previewImageUrl, setPreviewImageUrl] = useState();
    const [pickImageModalIsVisible, setPickCMSImageModalIsVisible] = useState(false);
    const [pickPreviewURLModalIsVisible, setPickPreviewURLModalIsVisible] = useState(false);
    const [pickVideoURLModalIsVisible, setPickVideoURLModalIsVisible] = useState(false);

    ////
    //// API.
    ////

    function onSessionDetailSuccess(response){
        console.log("onSessionDetailSuccess: Starting...");
        setSession(response);
        const exercise = response.videoSections[vsid].exercises[eid];
        setName(exercise.name);
        setType(exercise.type);
        setDuration(exercise.duration);
        setPreviewUrl(exercise.previewUrl);
        setPreviewImageUrl(exercise.previewImageUrl);
        setRestUpcomingName(exercise.restUpcomingName);
        setPreviewDescription(exercise.previewDescription);
        setVideoUrl(exercise.videoUrl);
    }

    function onSessionDetailError(apiErr) {
        console.log("onSessionDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionDetailDone() {
        console.log("onSessionDetailDone: Starting...");
        setFetching(false);
    }

    function onSessionUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Exercise updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Redirect the user to a new page.
        setForceURL("/user/" + uid + "/session/" + sid + "/video-section/" + vsid + "/exercise/" + eid);
    }

    function onSessionUpdateError(apiErr) {
        console.log("onSessionUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionUpdateError: Delayed for 2 seconds.");
            console.log("onSessionUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();

        // Reload the session template upon errors.
        setFetching(true);
        getSessionDetailAPI(
            sid,
            onSessionDetailSuccess,
            onSessionDetailError,
            onSessionDetailDone
        );
    }

    function onSessionUpdateDone() {
        console.log("onSessionUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Beginning...");
        setErrors({});
        setFetching(true);

        const exercise = {
          "duration": parseInt(duration),
          "name": name,
          "preview_description": previewDescription,
          "preview_image_url": previewImageUrl,
          "preview_url": previewUrl,
          "rest_upcoming_name": restUpcomingName,
          "type": type,
          "video_url": videoUrl,
        };
        console.log("onSubmitClick: Adding to exercises array...");
        session["videoSections"][vsid]["exercises"][eid] = exercise;

        console.log("onSubmitClick: Payload:", session);

        console.log("onSubmitClick: Please wait");
        putSessionUpdateAPI(session, onSessionUpdateSuccess, onSessionUpdateError, onSessionUpdateDone);
    }

    const onCMSImagePicked = (img) => {
        console.log("onCMSImagePicked:", img);
        if (img !== undefined && img !== null && img !== "") {
            setPreviewImageUrl(img.publicObjectUrl);
        }
        setPickCMSImageModalIsVisible(false);
    }

    const onPreviewURLPicked = (v) => {
        console.log("onPreviewURLPicked:", v);
        if (v !== undefined && v !== null && v !== "") {
            setPreviewUrl(v.m3u8PublicObjectUrl);
        }
        setPickPreviewURLModalIsVisible(false);
    }

    const onVideoURLPicked = (v) => {
        console.log("onVideoURLPicked:", v);
        if (v !== undefined && v !== null && v !== "") {
            setVideoUrl(v.m3u8PublicObjectUrl);
        }
        setPickVideoURLModalIsVisible(false);
    }

    const onPreviewDescriptionChange = (e, i) => {
        // For debugging purposes.
        console.log(e, i);

        // Make a copy of the "array of strings" into a mutable array.
        const copyOfArr = [...previewDescription];

        // Update record.
        copyOfArr[i] = e

        // Save to our react state.
        setPreviewDescription(copyOfArr);
    }

    const onRemoveListInputFieldChange = (i) => {
        // For debugging purposes.
        console.log(i);

        // Make a copy of the "array of strings" into a mutable array.
        const copyOfArr = [...previewDescription];

        // Delete record.
        const x = copyOfArr.splice(i, 1);

        // For debugging purposes.
        console.log(x);

        // Save to our react state.
        setPreviewDescription(copyOfArr);
    }

    const onAddListInputFieldClick = () => {
        // For debugging purposes.
        console.log("add");

        // Make a copy of the "array of strings" into a mutable array.
        let copyOfArr = [];
        if (previewDescription && previewDescription.length > 0) { // Defensive code.
            copyOfArr = [...previewDescription];
        }

        // Add empty record.
        copyOfArr.push("");

        // For debugging purposes.
        console.log(copyOfArr);

        // Save to our react state.
        setPreviewDescription(copyOfArr);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionDetailAPI(
                sid,
                onSessionDetailSuccess,
                onSessionDetailError,
                onSessionDetailDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <PickCMSImageModal
                isVisible={pickImageModalIsVisible}
                setIsVisible={setPickCMSImageModalIsVisible}
                onClick={onCMSImagePicked}
            />
            <PickCMSVideoModal
                modalTitle={"Pick Preview Video"}
                isVisible={pickPreviewURLModalIsVisible}
                setIsVisible={setPickPreviewURLModalIsVisible}
                onClick={onPreviewURLPicked}
            />
            <PickCMSVideoModal
                modalTitle={"Pick Video"}
                isVisible={pickVideoURLModalIsVisible}
                setIsVisible={setPickVideoURLModalIsVisible}
                onClick={onVideoURLPicked}
            />
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/users" aria-current="page"><FontAwesomeIcon className="fas" icon={faUsers} />&nbsp;Users</Link></li>
                            <li class=""><Link to={`/user/${uid}/sessions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Sessions)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-sections`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Detail (Video Sections)</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faVideo} />&nbsp;Video Section</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercises`} aria-current="page"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercises</Link></li>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercise</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Update</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eid}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Exercise</Link></li>
                        </ul>
                    </nav>

                    {/* Page */}
                    <nav class="box">
                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faDumbbell} />&nbsp;Exercise - {user.firstName} {user.lastName}</p>
                        <p class="subtitle is-6"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Edit Exercise</p>

                        <FormErrorBox errors={errors} />

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Loading..."} />
                            :
                            <>
                                <div class="container">
                                    <FormInputField
                                        label="Name"
                                        name="name"
                                        type="text"
                                        placeholder="Text input"
                                        value={name}
                                        errorText={errors && errors.name}
                                        helpText=""
                                        onChange={(e)=>setName(e.target.value)}
                                        isRequired={true}
                                        maxWidth="385px"
                                    />

                                    <FormRadioField
                                        label="Type"
                                        name="type"
                                        value={type}
                                        opt1Value="video"
                                        opt1Label="Video"
                                        opt2Value="rest"
                                        opt2Label="Rest"
                                        errorText={errors && errors.type}
                                        onChange={(e)=>setType(e.target.value)}
                                        maxWidth="180px"
                                    />

                                    <FormInputField
                                        label="Duration (measured in minutes)"
                                        name="duration"
                                        type="number"
                                        placeholder="Number input"
                                        value={duration}
                                        errorText={errors && errors.duration}
                                        helpText=""
                                        onChange={(e)=>setDuration(e.target.value)}
                                        isRequired={true}
                                        maxWidth="70px"
                                    />

                                    <FormListInputField
                                        label="Preview Description"
                                        name="previewDescription"
                                        type="text"
                                        placeholder="Text input"
                                        value={previewDescription}
                                        errorText={errors && errors.previewDescription}
                                        helpText=""
                                        onListInputFieldChange={onPreviewDescriptionChange}
                                        onRemoveListInputFieldChange={onRemoveListInputFieldChange}
                                        onAddListInputFieldClick={onAddListInputFieldClick}
                                        isRequired={true}
                                        maxWidth="100%"
                                    />

                                    <FormInputFieldWithButton
                                        label="Preview URL (Deprecated)"
                                        name="previewUrl"
                                        type="text"
                                        placeholder="Text input"
                                        value={previewUrl}
                                        errorText={errors && errors.previewUrl}
                                        helpText=""
                                        onChange={(e)=>setPreviewUrl(e.target.value)}
                                        isRequired={true}
                                        maxWidth="100%"
                                        buttonLabel={"Select Video"}
                                        onButtonClick={(e)=>setPickPreviewURLModalIsVisible(!pickPreviewURLModalIsVisible)}
                                    />

                                    <FormInputFieldWithButton
                                        label="Preview Image URL"
                                        name="previewImageUrl"
                                        type="text"
                                        placeholder="Text input"
                                        value={previewImageUrl}
                                        errorText={errors && errors.previewImageUrl}
                                        helpText=""
                                        onChange={(e)=>setPreviewImageUrl(e.target.value)}
                                        isRequired={true}
                                        disabled={false}
                                        maxWidth="100%"
                                        buttonLabel={"Select Image URL"}
                                        onButtonClick={(e)=>setPickCMSImageModalIsVisible(!pickImageModalIsVisible)}
                                    />

                                    <FormInputFieldWithButton
                                        label="Video URL"
                                        name="videoUrl"
                                        type="text"
                                        placeholder="Text input"
                                        value={videoUrl}
                                        errorText={errors && errors.videoUrl}
                                        helpText=""
                                        onChange={(e)=>setVideoUrl(e.target.value)}
                                        isRequired={true}
                                        maxWidth="100%"
                                        buttonLabel={"Select Video"}
                                        onButtonClick={(e)=>setPickVideoURLModalIsVisible(!pickVideoURLModalIsVisible)}
                                    />

                                    <FormInputField
                                        label="Rest Upcoming Name (Optional)"
                                        name="restUpcomingName"
                                        type="text"
                                        placeholder="Text input"
                                        value={restUpcomingName}
                                        errorText={errors && errors.restUpcomingName}
                                        helpText=""
                                        onChange={(e)=>setRestUpcomingName(e.target.value)}
                                        isRequired={true}
                                        maxWidth="400px"
                                    />

                                    <div class="columns">
                                        <div class="column is-half">
                                            <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eid}`} class="button is-hidden-touch"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                            <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${eid}`} class="button is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                        </div>
                                        <div class="column is-half has-text-right">
                                            <button onClick={onSubmitClick} class="button is-primary is-hidden-touch"><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                            <button onClick={onSubmitClick} class="button is-primary is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                        </div>
                                    </div>

                                </div>
                            </>
                        }
                    </nav>
                </section>
            </div>
        </>
    );
}


export default UserSessionVideoSectionExerciseUpdate;
